/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Divisions_EmptyInputs */

const th_divisions_empty = /** @type {(inputs: Divisions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีรุ่นการแข่งขัน`)
};

const en_divisions_empty = /** @type {(inputs: Divisions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No divisions available yet.`)
};

const ja_divisions_empty = /** @type {(inputs: Divisions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用できる部門はまだありません。`)
};

const zh_divisions_empty = /** @type {(inputs: Divisions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无分区。`)
};

const es_divisions_empty = /** @type {(inputs: Divisions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay categorías disponibles.`)
};

const pt_divisions_empty = /** @type {(inputs: Divisions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma categoria disponível ainda.`)
};

const id_divisions_empty = /** @type {(inputs: Divisions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada divisi.`)
};

const fr_divisions_empty = /** @type {(inputs: Divisions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune catégorie disponible pour l’instant.`)
};

const tl_divisions_empty = /** @type {(inputs: Divisions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang dibisyon.`)
};

const vi_divisions_empty = /** @type {(inputs: Divisions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có bảng nào.`)
};

const ko_divisions_empty = /** @type {(inputs: Divisions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 디비전이 없습니다.`)
};

const de_divisions_empty = /** @type {(inputs: Divisions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Klassen verfügbar.`)
};

const ru_divisions_empty = /** @type {(inputs: Divisions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дивизионов пока нет.`)
};

const tr_divisions_empty = /** @type {(inputs: Divisions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henüz grup yok.`)
};

const it_divisions_empty = /** @type {(inputs: Divisions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessuna categoria.`)
};

const pl_divisions_empty = /** @type {(inputs: Divisions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie ma jeszcze grup.`)
};

const uk_divisions_empty = /** @type {(inputs: Divisions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дивізіонів поки немає.`)
};

const hi_divisions_empty = /** @type {(inputs: Divisions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी कोई वर्ग नहीं।`)
};

const ar_divisions_empty = /** @type {(inputs: Divisions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد فئات بعد.`)
};

const ms_divisions_empty = /** @type {(inputs: Divisions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada divisyen.`)
};

const bn_divisions_empty = /** @type {(inputs: Divisions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এখনও কোনও বিভাগ নেই।`)
};

const zh_tw2_divisions_empty = /** @type {(inputs: Divisions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚無分組。`)
};

const zh_hk2_divisions_empty = /** @type {(inputs: Divisions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚無組別。`)
};

const ur_divisions_empty = /** @type {(inputs: Divisions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابھی کوئی درجہ نہیں۔`)
};

const fa_divisions_empty = /** @type {(inputs: Divisions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هنوز گروهی نیست.`)
};

const sw_divisions_empty = /** @type {(inputs: Divisions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna madaraja bado.`)
};

const nl_divisions_empty = /** @type {(inputs: Divisions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen klassen.`)
};

/**
* | output |
* | --- |
* | "No divisions available yet." |
*
* @param {Divisions_EmptyInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const divisions_empty = /** @type {((inputs?: Divisions_EmptyInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Divisions_EmptyInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_divisions_empty(inputs)
	if (locale === "ja") return ja_divisions_empty(inputs)
	if (locale === "zh") return zh_divisions_empty(inputs)
	if (locale === "es") return es_divisions_empty(inputs)
	if (locale === "pt") return pt_divisions_empty(inputs)
	if (locale === "id") return id_divisions_empty(inputs)
	if (locale === "fr") return fr_divisions_empty(inputs)
	if (locale === "tl") return tl_divisions_empty(inputs)
	if (locale === "vi") return vi_divisions_empty(inputs)
	if (locale === "ko") return ko_divisions_empty(inputs)
	if (locale === "de") return de_divisions_empty(inputs)
	if (locale === "ru") return ru_divisions_empty(inputs)
	if (locale === "tr") return tr_divisions_empty(inputs)
	if (locale === "it") return it_divisions_empty(inputs)
	if (locale === "pl") return pl_divisions_empty(inputs)
	if (locale === "uk") return uk_divisions_empty(inputs)
	if (locale === "hi") return hi_divisions_empty(inputs)
	if (locale === "ar") return ar_divisions_empty(inputs)
	if (locale === "ms") return ms_divisions_empty(inputs)
	if (locale === "bn") return bn_divisions_empty(inputs)
	if (locale === "zh-TW") return zh_tw2_divisions_empty(inputs)
	if (locale === "zh-HK") return zh_hk2_divisions_empty(inputs)
	if (locale === "ur") return ur_divisions_empty(inputs)
	if (locale === "fa") return fa_divisions_empty(inputs)
	if (locale === "sw") return sw_divisions_empty(inputs)
	if (locale === "nl") return nl_divisions_empty(inputs)
	return en_divisions_empty(inputs)
});